import VectorLayer from 'ol/layer/Vector';
import { Vector } from 'ol/source';
import Style from 'ol/style/Style';
import { useEffect } from 'react';
import useTransientStore from "../../data/transcientStore";
import { useTranslation } from "../../hooks/useTranslation";

interface VectorLayerProps {
    source: Vector;
    style: Style;
    zIndex?: number;
    minZoom?: number;
    maxZoom?: number;
    visible?: boolean;
}

export default function VectorLayerWrapper({ source, style, zIndex = 0, minZoom = 0, maxZoom = 20, visible = true }: VectorLayerProps) {
  const selectedAddressSystem = useTransientStore((state) => state.selectedAddressSystem);
  const addrIdFromStore = selectedAddressSystem?.id || 0;

  const { getTranslation } = useTranslation({ pageId: 303, addressSystemId: addrIdFromStore || 0, autoLoad: true });
    const map = useTransientStore((state) => state.map);

    useEffect(() => {
        if (!map) return;
        const view = map.getView();
        const minResolution = view.getResolutionForZoom(maxZoom + 1);
        const maxResolution = view.getResolutionForZoom(minZoom);

        const vectorLayer = new VectorLayer({
            source,
            style: style,
            minResolution,
            maxResolution,
            visible: visible,
            updateWhileAnimating: true,
            updateWhileInteracting: true
        });

        map.addLayer(vectorLayer);
        vectorLayer.setZIndex(zIndex);

        return () => {
            if (map) {
                map.removeLayer(vectorLayer);
            }
        };
    }, [map, maxZoom, minZoom, source, style, zIndex, visible]);

    return null;
}